import React from 'react'
import styled from 'styled-components'
import {
  magicContainerStyle,
  titleStyle2,
  textStyle1,
} from 'components/magic/styled'
import Image from '../../Image'
import mediaQuery from '../../../styles/mediaQuery'
import GradientLink from '../GradientLink'

const Section = styled.section`
  background-color: ${({ isGray }) => (isGray ? '#18181C' : 'transparent')};
  padding: 30px 0;

  ${mediaQuery.tablet} {
    padding: 80px 0;
  }

  ${mediaQuery.bigTabletMin} {
    padding: 124px 0;
  }
`

const Container = styled.div`
  ${magicContainerStyle};

  ${mediaQuery.bigTabletMin} {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`
const Title = styled.h4`
  ${titleStyle2};
  margin-bottom: 24px;
`
const Text = styled.p`
  ${textStyle1};
  margin-bottom: 24px;
`

const TitleColumn = styled.div`
  ${textStyle1};
  margin-bottom: 24px;
  flex: 0 0 460px;
  order: 2;
  padding: 0 15px;
`

const ImageColumn = styled.div`
  order: ${({ isReverted }) => (isReverted ? 3 : 1)};

  ${mediaQuery.tabletMax} {
    margin-bottom: 30px;
  }

  ${mediaQuery.tablet} {
    flex: 0 0 400px;
  }

  ${mediaQuery.bigTabletMin} {
    flex: 0 0 540px;
  }
`

const ImageStyled = styled(Image)`
  width: 100%;
  max-width: 100%;
  border-radius: 28px;
`

const FeatureSection = ({
  isReverted,
  image,
  title,
  text,
  href,
  linkText,
  id,
}) => (
  <Section isGray={isReverted} id={id}>
    <Container>
      <ImageColumn isReverted={isReverted}>
        <ImageStyled fileName={image} alt={title} />
      </ImageColumn>
      <TitleColumn>
        <Title>{title}</Title>
        <Text>{text}</Text>
        <GradientLink url={href} title={linkText || 'Get started'} />
      </TitleColumn>
    </Container>
  </Section>
)

export default FeatureSection
